import React, { FC, Dispatch, SetStateAction } from "react";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import AddressInput from "./AddressInput";

const StyledShipDiv = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
  paddingBottom: 30,
  width: "80%",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
  },
}));

const StyledShipLeftDiv = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  paddingRight: 20,
  [theme.breakpoints.down("lg")]: {
    paddingBottom: 10,
    paddingRight: 0,
  },
}));

interface DeliveryInfoProps {
  address: string;
  city: string;
  zip: string;
  state: string;
  dealerDelivery: boolean;
  signInRole: string;
  handleAddress?: (place: google.maps.places.PlaceResult) => void;
  addressErr: boolean;
  setAddressErr: Dispatch<SetStateAction<boolean>>
}

const DeliveryInfo: FC<DeliveryInfoProps> = ({
  address,
  city,
  zip,
  state,
  dealerDelivery,
  signInRole,
  handleAddress,
  addressErr,
  setAddressErr
}) => {
  const isAdmins =
    signInRole === "Admin" || signInRole === "Inside Sales" ? true : false;

  const disabled = dealerDelivery && !isAdmins ? true : false;

  return (
    <>
      <StyledShipDiv>
        <StyledShipLeftDiv>
          <Typography variant="body2" style={{ paddingRight: 20 }}>
            Address: <span style={{ color: "red", fontSize: 22 }}>* </span>
          </Typography>

          <AddressInput
            disabled={disabled}
            address={address}
            city={city}
            zip={zip}
            state={state}
            onSelect={handleAddress}
            addressErr={addressErr}
            setAddressErr={setAddressErr}
          />
        </StyledShipLeftDiv>
      </StyledShipDiv>
    </>
  );
};

export default DeliveryInfo;
